import React, { useState } from "react";
import { Card, Table, Button, Modal } from "react-bootstrap";

const InvoiceHistory = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ field: "date", direction: "desc" });
  const recordsPerPage = 6;

  const invoices = [
    {
      id: "B9E58538-0001",
      plan: "Basic",
      amount: 97.50,
      date: "3/5/2024",
      status: "Success"
    },
    {
      id: "B9E58538-0002",
      plan: "Premium",
      amount: 199.99,
      date: "2/15/2024",
      status: "Failed"
    },
    {
      id: "B9E58538-0003",
      plan: "Basic",
      amount: 97.50,
      date: "1/20/2024",
      status: "Success"
    },
    {
      id: "B9E58538-0004",
      plan: "Premium",
      amount: 199.99,
      date: "12/10/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0005",
      plan: "Basic",
      amount: 97.50,
      date: "11/5/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0006",
      plan: "Premium",
      amount: 199.99,
      date: "10/15/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0007",
      plan: "Basic",
      amount: 97.50,
      date: "9/20/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0008",
      plan: "Premium",
      amount: 199.99,
      date: "8/10/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0009",
      plan: "Basic",
      amount: 97.50,
      date: "7/5/2023",
      status: "Success"
    },
    {
      id: "B9E58538-0010",
      plan: "Premium",
      amount: 199.99,
      date: "6/15/2023",
      status: "Success"
    }
  ];

  const sortData = (data) => {
    return [...data].sort((a, b) => {
      if (sortConfig.field === "date") {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return sortConfig.direction === "asc" 
          ? dateA.getTime() - dateB.getTime()
          : dateB.getTime() - dateA.getTime();
      } else if (sortConfig.field === "status") {
        return sortConfig.direction === "asc"
          ? a.status.localeCompare(b.status)
          : b.status.localeCompare(a.status);
      }
      return 0;
    });
  };

  const handleSort = (field) => {
    setSortConfig((prevConfig) => ({
      field,
      direction: 
        prevConfig.field === field && prevConfig.direction === "asc" 
          ? "desc" 
          : "asc",
    }));
  };

  const getSortIcon = (field) => {
    if (sortConfig.field !== field) {
      return <img src="/assets/arrow-down-gray.svg" alt="Sort" />;
    }
    return (
      <img 
        src={`/assets/${sortConfig.direction === 'asc' ? 'arrow-up' : 'arrow-down'}-gray.svg`} 
        alt={`Sort ${sortConfig.direction}`} 
      />
    );
  };

  const sortedInvoices = sortData(invoices);
  const initialRecords = sortedInvoices.slice(0, 3);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedInvoices.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(invoices.length / recordsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <Card className="shadow-sm border-0 p-4 rounded-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1">Invoice History</h5>
            <p className="text-muted small mb-0">View and download your invoices</p>
          </div>
          <Button 
            variant="link" 
            className="text-decoration-none"
            onClick={() => setShowModal(true)}
          >
            <img
              src="assets/arrow-right-sm.svg"
              alt="Arrow Right"
              className="nav-icon"
            />
          </Button>
        </div>

        <Table hover className="mt-3">
          <thead>
            <tr className="text-secondary">
              <th>Invoice Number</th>
              <th>Plan</th>
              <th>Amount</th>
              <th onClick={() => handleSort("date")} style={{ cursor: "pointer" }}>
                Date {getSortIcon("date")}
              </th>
              <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                Status {getSortIcon("status")}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody className="text-secondary">
            {initialRecords.map((invoice) => (
              <tr key={invoice.id}>
                <td className="text-dark">{invoice.id}</td>
                <td>{invoice.plan}</td>
                <td>${invoice.amount.toFixed(2)}</td>
                <td>{invoice.date}</td>
                <td>
                  <span className={`badge ${invoice.status === 'Success' ? 'bg-success' : 'bg-danger'} bg-opacity-10 ${
                    invoice.status === 'Success' ? 'text-success' : 'text-danger'
                  }`}>
                    {invoice.status}
                  </span>
                </td>
                <td className="text-start">
                  <Button variant="link" className="p-0">
                    <img src="/assets/download-purple.svg" alt="Download" className="img-fluid" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              <img src="/assets/history-rounded.svg" alt="Clock" className="me-2" />
              <span>Invoice History</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-end align-items-center mb-4">
            <Button variant="outline-primary" className="support-button">
              <img src="/assets/download-blue.svg" alt="Icon" className="img-fluid me-2 icon-svg" />
              Download CSV
            </Button>
          </div>

          <Card className="border border-secondary-subtle rounded-4">
            <Table hover className="mb-0 rounded-4 overflow-hidden">
              <thead>
                <tr className="text-secondary">
                  <th>Invoice</th>
                  <th>Plan</th>
                  <th>Amount</th>
                  <th onClick={() => handleSort("date")} style={{ cursor: "pointer" }}>
                    Date {getSortIcon("date")}
                  </th>
                  <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                    Status {getSortIcon("status")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="text-secondary">
                {currentRecords.map((invoice) => (
                  <tr key={invoice.id}>
                    <td className="text-dark">{invoice.id}</td>
                    <td>{invoice.plan}</td>
                    <td>${invoice.amount.toFixed(2)}</td>
                    <td>{invoice.date}</td>
                    <td>
                      <span className={`badge ${invoice.status === 'Success' ? 'bg-success' : 'bg-danger'} bg-opacity-10 ${
                        invoice.status === 'Success' ? 'text-success' : 'text-danger'
                      }`}>
                        {invoice.status}
                      </span>
                    </td>
                    <td className="text-start">
                      <Button variant="link" className="p-0">
                        <img src="/assets/download-purple.svg" alt="Download" className="img-fluid" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>

          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button
              variant="outline-secondary"
              className="border-dark-subtle"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Previous
            </Button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <Button
              variant="outline-primary"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InvoiceHistory;